import type { VoidFunctionComponent } from 'react';

import { Badge } from '../../../generic/Badge';

type Props = {
  isDeclared: boolean;
};

/**
 * FileViewerBadge displays the "Declared" or "Discovered" badge
 * in the header area of the FileViewer.
 */
const FileViewerBadge: VoidFunctionComponent<Props> = ({ isDeclared }) => (
  <Badge color="light-gray">
    {isDeclared ? 'DECLARED' : 'DISCOVERED'}
  </Badge>
);

export default FileViewerBadge;
